<div class="section-basic">

  <form class="m-form" [formGroup]="form" (keydown.enter)="$event.preventDefault();" autocomplete="off" novalidate>

    <div class="form-group m-form__group default-style datepicker-group">
      <label>기간</label>
      <div class="input-group">
        <input [matDatepicker]="start" [max]="maxDate" (click)="start.open()" class="form-control m-input"
          formControlName="gte_date" (dateChange)="onChangeStartDate()">
        <mat-datepicker #start></mat-datepicker>

        <button class="btn btn-secondary" type="button"></button>

        <mat-datepicker #end></mat-datepicker>
        <input [matDatepicker]="end" [min]="minDate" [max]="maxDate" (click)="end.open()" class="form-control m-input"
          formControlName="lte_date" (dateChange)="onChangeEndDate()">
      </div>
    </div>

    <app-dept-auto-complete [initLoginDeptFlg]="true" (selected)="selectDept($event)"></app-dept-auto-complete>

    <div class="form-group m-form__group default-style">
      <button class="btn btn-sm btn-primary btn_search" (click)="search()">검색</button>
    </div>

  </form>

</div>

<div class="result">
  <div class="section-basic">

    <div class="btns_right_align">
      <button class="btn btn-sm btn-outline-primary" (click)="exportTOExcel()">엑셀 다운로드</button>
    </div>

    <div class="m--space-20"></div>

    <div class="statistics-mat-table" #TABLE>

      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="search_yyyy_mm">
          <mat-header-cell *matHeaderCellDef>년월</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.search_yyyy_mm}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="recycle_place_name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>되살림터</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.recycle_place_name}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="give_good_cate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>물품구분</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.give_good_cate}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="give_good_detail_cate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>물품상세</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.give_good_detail_cate}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="general_shipping">
          <mat-header-cell *matHeaderCellDef mat-sort-header>일반출고</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.general_shipping | currencyMask}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="event_shipping">
          <mat-header-cell *matHeaderCellDef mat-sort-header>행사출고</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.event_shipping | currencyMask}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="sharing_shipping">
          <mat-header-cell *matHeaderCellDef mat-sort-header>현물나눔출고</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.sharing_shipping | currencyMask}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="no_tag_shipping_general">
          <mat-header-cell *matHeaderCellDef mat-sort-header>무택출고(무택일반)</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.no_tag_shipping_general | currencyMask}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="no_tag_shipping_material">
          <mat-header-cell *matHeaderCellDef mat-sort-header>무택출고(원재료)</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.no_tag_shipping_material | currencyMask}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="no_tag_shipping_fixtures">
          <mat-header-cell *matHeaderCellDef mat-sort-header>무택출고(비품)</mat-header-cell>
          <mat-cell *matCellDef="let element">{{element.no_tag_shipping_fixtures | currencyMask}}</mat-cell>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

    </div>

  </div>

</div>

<fc-detail-fabs [listDisabled]="true"></fc-detail-fabs>